import { Nullable } from "@tager/admin-services";
import { SingleFileInputValueType } from "@tager/admin-ui";

import { FullBrandType } from "@/typings/model";
import { BrandCreationPayload, BrandUpdatePayload } from "@/services/requests";
import { createFileInputValue } from "@/utils/common";

export type FormValues = {
  name: string;
  description: string;
  image: Nullable<SingleFileInputValueType>;
  urlAlias: string;
  content: string;
  pageDescription: string;
  openGraphImage: Nullable<SingleFileInputValueType>;
  pageTitle: string;
};

export function convertBrandToFormValues(
  brand: Nullable<FullBrandType>
): FormValues {
  if (!brand) {
    return {
      name: "",
      description: "",
      image: null,
      content: "",
      urlAlias: "",
      pageDescription: "",
      openGraphImage: null,
      pageTitle: "",
    };
  }
  return {
    name: brand.name,
    description: brand.description ?? "",
    image: brand.image ? createFileInputValue(brand.image) : null,
    urlAlias: brand.urlAlias ?? "",
    content: brand.content ?? "",
    pageDescription: brand.pageDescription ?? "",
    openGraphImage: brand.openGraphImage
      ? createFileInputValue(brand.openGraphImage)
      : null,
    pageTitle: brand.pageTitle ?? "",
  };
}

export function convertFormValuesToBrandCreationPayload(
  values: FormValues
): BrandCreationPayload {
  return {
    name: values.name ?? "",
  };
}

export function convertFormValuesToBrandUpdatePayload(
  values: FormValues
): BrandUpdatePayload {
  return {
    name: values.name ?? "",
    description: values.description ?? "",
    image: values.image?.file.id ?? null,
    urlAlias: values.urlAlias ?? "",
    content: values.content ?? "",
    pageDescription: values.pageDescription ?? "",
    openGraphImage: values.openGraphImage?.file.id ?? null,
    pageTitle: values.pageTitle ?? "",
  };
}
